module.exports = __webpack_public_path__ + "static/img/dqms.b94e8d80.png";